var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M30.726 11.855c-.059-.766-1.09-6.796-5.55-11.12 6.592.8 10.971 7.015 10.289 12.838-.682 5.823-4.495 8.412-6.609 9.526 1.89-3.878 2.232-6.53 1.87-11.244Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M30.726 12.154c-.059-.766-1.09-6.797-5.55-11.12 6.592.8 10.971 7.015 10.289 12.838-.682 5.823-4.495 8.412-6.609 9.526 1.89-3.878 2.232-6.53 1.87-11.244Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M31.445 25.212c.646-.416 5.463-4.19 7.147-10.169 2.428 6.181-.958 12.987-6.406 15.155-5.447 2.167-9.538.043-11.522-1.288 4.31-.18 6.807-1.14 10.781-3.698Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M20.71 32.01c.685.35 6.366 2.62 12.383 1.075-4.126 5.203-11.712 5.692-16.322 2.069-4.61-3.623-4.826-8.227-4.672-10.611 2.32 3.636 4.404 5.314 8.612 7.467Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M9.064 25.812c.089.763 1.355 6.75 5.982 10.895-6.619-.542-11.238-6.58-10.785-12.425.453-5.846 4.162-8.582 6.23-9.778-1.735 3.949-1.974 6.613-1.427 11.308Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M9.064 26.113c.089.763 1.355 6.749 5.982 10.895-6.619-.543-11.238-6.58-10.785-12.425.453-5.846 4.162-8.583 6.23-9.778-1.735 3.948-1.974 6.613-1.427 11.308Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M8.488 12.488c-.642.422-5.426 4.236-7.06 10.23-2.48-6.16.848-12.995 6.277-15.209 5.429-2.214 9.537-.125 11.533 1.189-4.308.217-6.797 1.198-10.75 3.79Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M8.488 12.789c-.642.421-5.426 4.236-7.06 10.23-2.48-6.16.848-12.995 6.277-15.21 5.429-2.213 9.537-.124 11.533 1.19-4.308.217-6.797 1.198-10.75 3.79Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M19.071 5.595c-.688-.341-6.398-2.54-12.395-.918 4.06-5.255 11.64-5.84 16.294-2.276 4.656 3.564 4.93 8.165 4.806 10.551-2.365-3.606-4.47-5.258-8.705-7.357Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#55C65C",
    d: "M19.071 5.896c-.688-.341-6.398-2.54-12.395-.918 4.06-5.255 11.64-5.84 16.294-2.276 4.656 3.564 4.93 8.165 4.806 10.55-2.365-3.605-4.47-5.257-8.705-7.356Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0143b468903a67dd878349018fb86288.svg";
export { ForwardRef as ReactComponent };